// Safari and Internet Explorer cannot parse dates (invalid date error) of a specific type of
// ISO formatting (RFC 822) that does no have timezone part (HHmm) separated by a colon (:)
// not working example: new Date('2018-02-06T20:00:00+1100')
// working example:     new Date('2018-02-06T20:00:00+11:00')
export const convertISODateFormat = (date: string) =>
	date.replace(/([+-][0-9]{2})([0-9]{2})$/, '$1:$2');
